module.exports = __webpack_public_path__ + "img/whats-new-6_en.22d3562.jpg";